var render = function () {
  var _vm$modalRef;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalWithEditBtn', {
    ref: "modalRef",
    attrs: {
      "api-code": _vm.AR_UAA01,
      "update-title": "ar_client_update_debit_account",
      "create-title": "ar_client_add_debit_account",
      "detail-title": "ar_client_detail_debit_account",
      "is-show": _vm.isShow,
      "is-update": _vm.accountId
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('update:isShow', false);
      },
      "submit": _vm.createUpdateAccount,
      "update:isShow": function ($event) {
        _vm.isShow = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShow = $event;
      }
    }
  }, [_c('FormItems', {
    ref: "formRef",
    attrs: {
      "disabled": (_vm$modalRef = _vm.modalRef) === null || _vm$modalRef === void 0 ? void 0 : _vm$modalRef.isViewOnly,
      "items": _vm.formItems,
      "formData": _vm.formData
    },
    on: {
      "update:formData": function ($event) {
        _vm.formData = $event;
      },
      "update:form-data": function ($event) {
        _vm.formData = $event;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }